import React from "react";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";

import Box from "@material-ui/core/Box";
import TablePagination from "@material-ui/core/TablePagination";

import TablePaginationActions from "./TablePaginationActions";
import Loader from "../Loader";

import colors from "../../../assets/style/colors";

const styles = {
  container: {
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
    margin: "0px",
    minHeight: "250px",
  },
  tableContainer: {
    overflow: "auto",
  },
  tableContainerFetching: {
    height: "calc(100vh - 240px)",
    maxHeight: "calc(100vh - 240px)",
  },
  pagination: {
    color: colors.black54,
    minHeight: "50px",
    maxHeight: "50px",
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
  },
};

const TableContainer = (props) => {
  const {
    classes,
    section,
    count,
    loadData,
    isFetching,
    onlyOneItem,
    initialLoad = true,
  } = props;
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const page =
    parseInt(new URLSearchParams(props.location.search).get("page")) || 0;

  React.useEffect(() => {
    if (!onlyOneItem && initialLoad) {
      loadData(rowsPerPage, page);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const changePage = (pageNumber, rowsPerPageValue = rowsPerPage) => {
    let currentUrlParams = new URLSearchParams(window.location.search);
    currentUrlParams.set("page", pageNumber);
    props.history.push(
      `${window.location.pathname}?${currentUrlParams.toString()}`
    );
    loadData(rowsPerPageValue, pageNumber);
  };

  const changeRowsPerPage = (e) => {
    const newValue = parseInt(e.target.value);
    setRowsPerPage(newValue);
    changePage(0, newValue);
  };

  return (
    <Box
      className={classes.container}
      style={{ boxShadow: props.noShadow ? "none" : "" }}
    >
      <Box
        className={`${
          isFetching ? classes.tableContainerFetching : classes.tableContainer
        } ${isFetching ? "flexCenter" : ""}`}
        style={{
          height: props.height || "calc(100vh - 240px)",
          maxHeight: props.height || "calc(100vh - 240px)",
        }}
      >
        {isFetching ? <Loader noDecoration /> : props.children}
      </Box>
      <Box>
        {count !== undefined && !onlyOneItem && (
          <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 25]}
            colSpan={3}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={changePage}
            onChangeRowsPerPage={changeRowsPerPage}
            ActionsComponent={TablePaginationActions}
            labelRowsPerPage={I18n.get("site_rowsPerPage")}
          />
        )}
      </Box>
    </Box>
  );
};

TableContainer.propTypes = {
  count: PropTypes.number,
  loadData: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
};

export default withStyles(styles)(withRouter(TableContainer));
